import { render, staticRenderFns } from "./CustomerPrice.vue?vue&type=template&id=6468fb91&"
import script from "./CustomerPrice.vue?vue&type=script&lang=js&"
export * from "./CustomerPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports